import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersThreeFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.95 18.943a1 1 0 0 1-1-1c0-.463-.183-2.01-2.53-2.492a1 1 0 1 1 .4-1.959c3.05.624 4.13 2.788 4.13 4.451a1 1 0 0 1-1 1M18.2 12.4a1.002 1.002 0 0 1-.351-1.937 1.77 1.77 0 0 0 1.141-1.639c0-.758-.489-1.43-1.217-1.666a1.001 1.001 0 0 1 .614-1.904 3.75 3.75 0 0 1 2.603 3.58 3.79 3.79 0 0 1-2.439 3.501 1 1 0 0 1-.35.064M2.05 18.943a1 1 0 0 1-1-1c0-1.663 1.08-3.827 4.13-4.45a1 1 0 1 1 .4 1.959c-2.347.48-2.53 2.028-2.53 2.491a1 1 0 0 1-1 1M5.8 12.4q-.176 0-.351-.065A3.785 3.785 0 0 1 3.01 8.841a3.75 3.75 0 0 1 2.603-3.587 1 1 0 1 1 .614 1.904A1.75 1.75 0 0 0 5.01 8.833a1.77 1.77 0 0 0 1.141 1.63 1.002 1.002 0 0 1-.351 1.936M11.93 14.516C6.95 14.516 4.72 17.27 4.72 20a.75.75 0 0 0 .75.75l12.918-.018a.75.75 0 0 0 .749-.75c0-2.721-2.23-5.466-7.208-5.466M11.93 13.001a4.88 4.88 0 0 0 4.875-4.876A4.88 4.88 0 0 0 11.93 3.25a4.88 4.88 0 0 0-4.875 4.875 4.88 4.88 0 0 0 4.875 4.876"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersThreeFilled);
export default ForwardRef;
